import { List } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { useTableConfig } from 'modules/Finance/PaymentProfiles/subcomponents/List/hooks/useTableConfig'
import GridSpinner from 'components/UI/GridSpinner'
import ShowMoreButton from 'components/ShowMoreButton'
import styles from 'modules/Finance/PaymentProfiles/subcomponents/List/List.module.scss'

const PaymentProfilesList = ({ data, loading, onChangePage, pagination, EmptyComponent }) => {
  const { tableState, tableConfig } = useTableConfig(
    { className: styles['payment-profiles-list'] },
    data,
  )

  return (
    <>
      <List
        Loader={() => <GridSpinner width={24} />}
        loading={loading}
        table={tableState}
        config={tableConfig}
        EmptyComponent={EmptyComponent}
      />
      <ShowMoreButton
        onClick={onChangePage}
        loading={loading}
        current={data?.length}
        total={pagination.total}
      />
    </>
  )
}

PaymentProfilesList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool,
  onChangePage: PropTypes.func,
  pagination: PropTypes.object,
  EmptyComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
}

export default PaymentProfilesList
